import { observable, runInAction } from "mobx";
import { api, apiOperacao } from "../../api";
import { ICalc, IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { sortBy, toast_error } from "../../utils";

export class _ClassificacaoStore {
  obs = observable({
    selectedEmpresa: newEmpresa() as IEmpresa,
    summary: [] as any,
    selectedTab: "summary" as string,
    chave: "" as string,
    classificar_todos: false as boolean,
    classificarItems: [] as any[],
    current_page: 1 as number,
    length_itens: 0 as number,
    results: [] as any[],
    date_start: "" as string,
    date_end: "" as string,
    loading: false as boolean,
    textFilter: "" as string,
    itens_processando: [] as string[],
    tasks_classificacao: [] as any[],
    length_tasks_classificacao: 0 as number,
    loading_itens: false as boolean,
  })

  setClassificarItems(items: any) {
    this.obs.classificarItems.push(items);
  }

  setClassificarItemsList(items: any[]) {
    this.obs.classificarItems = items;
  }

  setClassificarItemsListNao(items) {
    this.obs.classificarItems = items;
  }

  deleteByIdClassificarItems(id: string) {
    this.obs.classificar_todos = false;
    this.obs.classificarItems = this.obs.classificarItems.filter(
      (value) => value["id"] != id
    );
  }

  resetClassificarItems() {
    this.obs.classificar_todos = false;
    this.obs.classificarItems = [];
  }

  selectAllClassificarLote() {
    this.resetClassificarItems();
    for (let i = 0; i < this.obs.results.length; i++) {
      let data = {
        id: this.obs.results[i].id.toString(),
        data: this.obs.results[i].data,
      };
      this.obs.classificarItems.push(data);
    }
  }

  async summary(empresa: IEmpresa, period: any) {
    this.obs.loading = true

    this.resetClassificarItems();

    let params = {
      period: period,
      empresa: empresa.cnpj,
    };

    try {

      let resp = await apiOperacao("classificacao").post("/classificacao/summary", { params: params });

      this.obs.summary = []

      if (resp.data.ok) {
        if (resp.data.total_summary == 0) {
          toast.warning('Não foram encontrados resultados.', {});
        } else {
          this.obs.summary = resp.data.summary
        }
      }
    } catch (ex) {
      toast_error(ex, `Erro ao consultar Classificação Sumário, tente novamente mais tarde.`);
    }

    this.obs.loading = false
  }

  async query(empresa: IEmpresa, period: any, text: string, page: number, chave: string) {

    this.obs.loading_itens = true

    this.resetClassificarItems();
    this.handldeItensProcessando();

    let params = {
      period: period,
      empresa: empresa.cnpj,
      text: text,
      page: page,
      page_size: 15,
      chave: chave
    };

    try {

      let resp = await apiOperacao("classificacao").post("/classificacao/paged", { params: params });
      this.obs.results = []

      if (resp.data.ok) {
        this.obs.length_itens = resp.data.items.length
        this.obs.results = resp.data.items
      }
    } catch (ex) {
      toast_error(ex, `Erro ao consultar Classificação de itens, tente novamente mais tarde.`);
    }

    this.obs.loading_itens = false

  }

  async query_all_itens_pages(empresa: IEmpresa, period: any, text: string, chave: string) {

    this.obs.classificarItems = []

    let currentPage = 1;

    while (true) {

      const params = {
        period: period,
        empresa: empresa.cnpj,
        text: text,
        page: currentPage,
        page_size: 5000,
        chave: chave
      };

      try {

        const resp = await apiOperacao("classificacao").post("/classificacao/paged", { params });

        const items = resp.data.items;

        if (items.length === 0) {
          break;
        }

        const novosIds = resp.data.items
          .map((item: any) => item.id || item._id)
          .filter((id: string) => !this.obs.itens_processando.includes(id));

        this.obs.classificarItems.push(...novosIds);

        currentPage++;

      } catch (error) { }

    }

  }

  async create_classificacao_task(contestacao: any, estado: string, classificacao: string) {

    try {

      const data = {
        data: contestacao,
        memoria_contestacao: false,
        estado: estado.toLowerCase(),
        periodo_inicial: this.obs.date_start,
        periodo_final: this.obs.date_end,
        cnpj: this.obs.selectedEmpresa.cnpj,
        classificacao: classificacao
      }

      let resp = await apiOperacao("classificacao").post("/classificacao/create-task", data);

      if (resp.data.ok) {

        toast.success("Classificação cadastrada com sucesso!", {});

        await this.query(this.obs.selectedEmpresa, [this.obs.date_start, this.obs.date_end], this.obs.textFilter, this.obs.current_page, this.obs.chave)

      } else {

        toast.error(resp.data.erro, {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao criar Task Contestação, tente novamente mais tarde.`);

    }

  }

  async handldeItensProcessando() {
    try {
      this.obs.itens_processando = []

      let resp = await apiOperacao("classificacao").get("/classificacao/index-contestacao-task-pendentes");

      this.obs.itens_processando = resp.data.items

    } catch (ex) {
      toast_error(ex, `Erro ao consultar Itens Processando, tente novamente mais tarde.`);
    }
  }

  async loadCalcs() {
    try {
      let resp;

      if (this.obs.selectedEmpresa.uf == "RS") {
        resp = await api.get("/api/calcs-rs")
      } else {
        resp = await api.get("/api/calcs")
      }

      return resp.data
    } catch (ex) {
      return []
    }
  }

  async handleConsultaTodas(paged: number, limit: number) {

    try {

      let data = {
        paged: paged,
        limit: limit
      }

      let resp = await apiOperacao("classificacao").post("/classificacao/tasks", data);

      this.obs.length_tasks_classificacao = 0
      this.obs.tasks_classificacao = []

      if (resp.data.itens.length > 0) {

        this.obs.tasks_classificacao = resp.data.itens
        this.obs.length_tasks_classificacao = resp.data.count
      }

    } catch (ex) {
      toast_error(ex, `Erro ao consultar Tasks Contestações, tente novamente mais tarde.`);

    }

  }

  async classificacao_revenda(nota_item_ids: any, cnpj: string) {

    try {

      const data = {
        nota_item_ids: nota_item_ids,
        cnpj: cnpj,
      }

      let resp = await apiOperacao("classificacao").post("/classificacao/create-revenda", data);

      if (resp.data.ok) {

        toast.success("Classificação cadastrada com sucesso!", {});

        await this.query(this.obs.selectedEmpresa, [this.obs.date_start, this.obs.date_end], this.obs.textFilter, this.obs.current_page, this.obs.chave)

      } else {

        toast.error(resp.data.erro, {});

      }

    } catch (ex) {
      toast_error(ex, `Erro ao criar Task Contestação, tente novamente mais tarde.`);

    }

  }

  options() {
    return [
      { id: "REVENDA", name: "Revenda de Mercadorias", icon: "currency_exchange" },
      { id: "USO E CONSUMO", name: "Uso e Consumo", icon: "work" },
      { id: "ATIVO IMOBILIZADO", name: "Ativo Imobilizado", icon: "barcode" },
      { id: "TRANSFERÊNCIA", name: "Transferência de Mercadoria", icon: "swap_horiz" },
      { id: "CONSERTO", name: "Retorno Remessa para Conserto", icon: "build" },
      { id: "COMODATO", name: "Remessa em Comodato", icon: "handshake" },
      { id: "COMBUSTÍVEL USO", name: "Compra de Combustível pra uso e Consumo", icon: "local_gas_station" },
      { id: "COMBUSTÍVEL REVENDA", name: "Compra de Combustível pra Revenda", icon: "sell" },
      { id: "SERVIÇO", name: "Compra para utilização na prestação do Serviço", icon: "engineering" },
      { id: "INDUSTRIALIZAÇÃO", name: "Insumos pra industrialização", icon: "precision_manufacturing" },
      { id: "ESTOQUE", name: "Baixa de Estoque", icon: "remove_shopping_cart" },
      { id: "BONIFICAÇÃO", name: "Bonificação", icon: "redeem" },
      { id: "MERCADORIA", name: "Retorno de Mercadoria", icon: "assignment_return" },
      { id: "GARANTIA", name: "Remessa em Garantia", icon: "verified" },
      { id: "FUTURA", name: "Remessa para entrega Futura", icon: "schedule" },
      { id: "DEVOLUÇÃO", name: "Devolução de Venda", icon: "undo" },
      { id: "OUTRAS ENTRADAS", name: "Outras entradas não especificadas", icon: "more_horiz" },
      { id: "DEMONSTRAÇÃO", name: "Entrada de Mercadoria para Demonstração", icon: "visibility" },
      { id: "CONSIGNAÇÃO", name: "Entrada de Mercadoria em Consignação", icon: "inventory_2" },
    ];
  }

  handleBuscaCalculo(calcs: ICalc[], estadual: boolean, classificacao: string) {

    const est_int = estadual ? "estadual" : "interestadual"

    let campo = "";

    if (classificacao == "USO E CONSUMO") {
      campo = "uso_consumo_";
    } else if (classificacao == "ATIVO IMOBILIZADO") {
      campo = "ativo_imobilizado_";
    } else if (classificacao == "TRANSFERÊNCIA") {
      campo = "transferencia_mercadorias_";
    } else if (classificacao == "CONSERTO") {
      campo = "remessa_conserto_";
    } else if (classificacao == "COMODATO") {
      campo = "remessa_comodato_";
    } else if (classificacao == "COMBUSTÍVEL USO") {
      campo = "combustivel_consumo_";
    } else if (classificacao == "COMBUSTÍVEL REVENDA") {
      campo = "combustivel_revenda_";
    } else if (classificacao == "SERVIÇO") {
      campo = "compra_prestacao_servico_";
    } else if (classificacao == "INDUSTRIALIZAÇÃO") {
      campo = "insumos_industrializacao_";
    } else if (classificacao == "ESTOQUE") {
      campo = "baixa_estoque_";
    } else if (classificacao == "BONIFICAÇÃO") {
      campo = "bonificacao_";
    } else if (classificacao == "MERCADORIA") {
      campo = "retorno_mercadoria_";
    } else if (classificacao == "GARANTIA") {
      campo = "remessa_garantia_";
    } else if (classificacao == "FUTURA") {
      campo = "remessa_entrega_futura_";
    } else if (classificacao ==  "DEVOLUÇÃO") {
      campo = "devolucao_venda_";
    } else if (classificacao ==  "OUTRAS ENTRADAS") {
      campo = "outras_entradas_";
    } else if (classificacao ==  "DEMONSTRAÇÃO") {
      campo = "mercadorias_demonstracao_";
    } else if (classificacao ==  "CONSIGNAÇÃO") {
      campo = "mercadorias_consignacao_";
    } else {
      toast.error("Não foi possível encontrar a classificação, tente novamente mais tarde!", {})
      return
    }

    const new_campo = (campo + est_int);

    const empresa = ClassificacaoStore.obs.selectedEmpresa

    const calcEmpresa = calcs?.map((calc: ICalc) => {

      const { simples_nacional, simples_nacional_excesso, regime_e_sem_regime, regime_especial } = calc;

      /** Empresa Simples Nacional sem excesso */
      if (empresa.simples_nacional && !empresa.simples_nacional_excesso && simples_nacional && !simples_nacional_excesso) {
        return calc
      }

      /** Empresa Simples Nacional com excesso */
      if (empresa.simples_nacional && empresa.simples_nacional_excesso && simples_nacional && simples_nacional_excesso) {
        return calc
      }

      /** Empresa com regime especial */
      if (!empresa.simples_nacional && !empresa.simples_nacional_excesso && empresa.regime_especial_icms_pa && (regime_e_sem_regime || regime_especial)) {
        return calc
      }

      /** Outros casos gerais para regime sem regime especial */
      if (!empresa.simples_nacional && !empresa.simples_nacional_excesso && !empresa.regime_especial_icms_pa && regime_e_sem_regime && !regime_especial) {
        return calc
      }

      return null

    }).filter(x => x)

    const calcEncontrado = calcEmpresa.find(calcs => calcs[new_campo]);

    return calcEncontrado

  }

}

export const ClassificacaoStore = new _ClassificacaoStore();